// THE SUPPORT MAILBOX — where a person writes when they cannot sign in
// (owner, 1 Oct 2026; doc/5.10.2026.md "Support mailbox — plan"). Someone who
// is signed in raises a support ticket inside the app instead, so the address
// is shown only before sign-in: the sign-in screen and the landing page.
//
// The address belongs to the STACK, not to this build (owner, 5 Oct 2026:
// support@mitraonecare.com is the temp server's alone; testing and dev name
// another or none). It comes from the backend's SUPPORT_EMAIL through the
// public GET /api/support-contact; null = no note at all.
import { useEffect, useRef, useState } from 'react';

// Asked once per page load and shared by every note on the page. `undefined`
// = not asked yet, `null` = this stack has no support address. A failed ask is
// not remembered, so the next screen asks again.
let cached;
let pending = null;

export function loadSupportEmail(get) {
  if (cached !== undefined) return Promise.resolve(cached);
  if (pending) return pending;
  let req = null;
  try { req = get(); } catch { req = null; }
  if (!req || typeof req.then !== 'function') return Promise.resolve(null);
  pending = req
    .then((res) => {
      const e = res?.data?.email;
      cached = typeof e === 'string' && e.trim() ? e.trim() : null;
      return cached;
    })
    .catch(() => null)
    .finally(() => { pending = null; });
  return pending;
}

// The support address of the stack this build talks to, or null.
export function useSupportEmail(get) {
  const getRef = useRef(get);
  getRef.current = get;
  const [email, setEmail] = useState(cached ?? null);
  useEffect(() => {
    let alive = true;
    loadSupportEmail(() => getRef.current()).then((e) => { if (alive) setEmail(e); });
    return () => { alive = false; };
  }, []);
  return email;
}

// Tests only: forget the answer between cases.
export function resetSupportEmailCache() {
  cached = undefined;
  pending = null;
}
